import { includes } from 'ramda';

/**
 * @description SUPER_ADMIN > ADMIN > PUBLIC_ADMIN
 */
export enum RoleEnum {
	SYS_ADMIN = 'SYS_ADMIN',
	MASTER_ADMIN = 'MASTER_ADMIN',
	SUPER_ADMIN = 'SUPER_ADMIN',
	ADMIN = 'ADMIN',
	PUBLIC_ADMIN = 'PUBLIC_ADMIN',
	FOREIGN_MASTER_ADMIN = 'FOREIGN_MASTER_ADMIN',
	FOREIGN_ADMIN = 'FOREIGN_ADMIN',
}

export const SYSTEM_ROLE_NAMES = [RoleEnum.SYS_ADMIN];

export const WORKER_ROLE_NAMES = [
	RoleEnum.MASTER_ADMIN,
	RoleEnum.SUPER_ADMIN,
	RoleEnum.ADMIN,
	RoleEnum.PUBLIC_ADMIN,
];

export const FOREIGN_ROLE_NAMES = [
	RoleEnum.FOREIGN_MASTER_ADMIN,
	RoleEnum.FOREIGN_ADMIN,
];

export const WORKER_MASTER_SUPER_ROLE_NAMES = [
	RoleEnum.MASTER_ADMIN,
	RoleEnum.SUPER_ADMIN,
];

export const WORKER_ADMIN_PUBLIC_ADMIN_ROLE_NAMES = [
	RoleEnum.ADMIN,
	RoleEnum.PUBLIC_ADMIN,
];

export const ROLE_OPTIONS = [
	{
		value: RoleEnum.SYS_ADMIN,
		label: '시스템 관리자',
	},
	{
		value: RoleEnum.MASTER_ADMIN,
		label: '마스터 관리자',
	},
	{
		value: RoleEnum.SUPER_ADMIN,
		label: '최고 관리자',
	},
	{
		value: RoleEnum.ADMIN,
		label: '관리자',
	},
	{
		value: RoleEnum.PUBLIC_ADMIN,
		label: '공공형 관리자',
	},
];

export const WORKER_ROLE_OPTIONS = [
	// {
	// 	value: RoleEnum.MASTER_ADMIN,
	// 	label: '마스터 관리자',
	// },
	{
		value: RoleEnum.SUPER_ADMIN,
		label: '최고 관리자',
	},
	{
		value: RoleEnum.ADMIN,
		label: '관리자',
	},
	{
		value: RoleEnum.PUBLIC_ADMIN,
		label: '공공형 관리자',
	},
];

export const getRolesForUser = (role: RoleEnum) => {
	switch (role) {
		case RoleEnum.MASTER_ADMIN:
		case RoleEnum.SUPER_ADMIN:
			return WORKER_ROLE_OPTIONS;
		case RoleEnum.ADMIN:
			return WORKER_ROLE_OPTIONS.filter((role) =>
				includes(role.value, WORKER_ADMIN_PUBLIC_ADMIN_ROLE_NAMES)
			);
		case RoleEnum.PUBLIC_ADMIN:
			return WORKER_ROLE_OPTIONS.filter((role) =>
				includes(role.value, [RoleEnum.PUBLIC_ADMIN])
			);
		default:
			return [];
	}
};
